;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { IssueCategory } from '@qogita/canary-client'
import { SaleGroupType } from 'src/deprecated/types/sales'

import { getPreparedParams } from './getPreparedParams'
import {
  SaleDestination,
  SaleNextAction,
  SaleSortBy,
} from './salesQueryParameter'

const generalRoutes = {
  home: '/',
  login: '/login/',
  logout: '/logout/',
  dashboard: '/dashboard/',
  activateAccount: '/activate-account/',
  myProfile: (queryParams: Record<string, string> = {}) => {
    const params = getPreparedParams(queryParams)

    return `/my-profile/?${params}`
  },
  orderPreferences: {
    discount: '/my-profile/discount',
    shipFrom: '/my-profile/shipping-from/',
    shippingAddress: '/my-profile/shipping-address/',
    chamberOfCommerce: '/my-profile/chamber-of-commerce/',
    billingAddress: '/my-profile/billing-address/',
    paymentDetails: '/my-profile/payment-details/',
  },
  stockIngestion: {
    connectionSettings: '/my-profile/connection-settings/',
  },
} as const

const sellersRoutes = {
  inventory: (queryParams: { page: number; brand?: string[] }) => {
    const params = getPreparedParams(queryParams)

    return `/inventory/?${params}`
  },
  inventorySingular: (qid: string) => `/inventory/${qid}/`,
  inventoryRanked: `/inventory/ranked/`,
  hiddenProducts: `/inventory/hidden-products`,
  orders: ({
    status,
    page,
    sort,
    destination,
    nextAction,
  }: {
    status: SaleGroupType | null
    page: number
    sort?: SaleSortBy
    destination?: SaleDestination
    nextAction?: SaleNextAction
  }) => {
    const params = getPreparedParams({
      status,
      page,
      sort,
      destination,
      nextAction,
    })

    return `/orders/?${params}`
  },
  claims: (queryParams: {
    page?: number
    claimCategory?: string
    filters?: string[]
    sort?: string
  }) => {
    const params = getPreparedParams(queryParams)
    return `/claims/?${params}`
  },
  order: (qid: string) => `/orders/${qid}/`,
  orderContact: ({
    saleQid,
    ...query
  }: {
    saleQid: string
    option?: IssueCategory
    requestedShippingCost?: string
  }) => `/orders/${saleQid}/contact/?${getPreparedParams(query)}`,
  internal: {
    sellerInitialChecker: '/internal/seller-initial-checker/',
    sellerOnboarding: '/internal/seller-onboarding/',
    sellerOnboardingSlug: (slug: string) =>
      `/internal/seller-onboarding/${slug}/`,
  },
  helpCenter: '/help-center/',
  trendingProducts: '/trending-products/',
  trendingProductsWatchlisted: '/trending-products/?tab=watchlisted',
  insights: '/insights/',
} as const

const logisticsRoutes = {
  incomingPackages: (args?: { page: number }) => {
    return `/warehouse/incoming/?page=${args?.page ?? 1}`
  },
  warehouse: '/warehouse/confirmed-packages/',
  shipments: '/warehouse/shipments/',
  shipmentsSingular: (args: { qid: string }) => {
    return `/warehouse/shipments/${args.qid}`
  },
  readyToShip: '/warehouse/ready-to-ship/',
  sellerOnboardingSlug: ({
    completedSuccessful,
  }: {
    completedSuccessful: boolean
  }) => {
    const params = getPreparedParams({
      completedSuccessful: completedSuccessful ? 'true' : undefined,
    })

    return `/internal/seller-onboarding?${params}`
  },
  sellerOnboardingFid: (args: { slug: string }) =>
    `/internal/seller-onboarding/${args.slug}`,
} as const

/**
 * @description E2E single source of truth and avoid duplications strings
 */
export const routes = {
  ...generalRoutes,
  ...sellersRoutes,
  ...logisticsRoutes,
} as const
